import { IconType } from "react-icons";
import { UserModuleNameTypes } from "./models/userAccess/UserAccess.model";
import { IoIosLink } from "react-icons/io";
import { MdAppRegistration } from "react-icons/md";

type NavItemTypeWithoutChild = {
    label: string;
    moduleName: string;
    path: string;
    badge?:boolean;
    icon: IconType;
    children?: never;
};

type NavItemTypeWithChild = {
    label: string;
    moduleName: string;
    path?: never;
    badge?:boolean;
    icon: IconType;
    children?: {
        label: string;
        badge?:boolean;
        moduleName: string;
        path: string;
        icon: IconType;
    }[];
};

export type NavItemType = NavItemTypeWithChild | NavItemTypeWithoutChild;

export const RegistrationNavigation: NavItemType[] = [
    {
        label: "Registration Links",
        moduleName: UserModuleNameTypes.REGISTRATION_LINKS,
        icon: IoIosLink,
        path: "registration-links",
      },
      {
        label: " Registration Requests",
        moduleName: UserModuleNameTypes.REGISTRATION_REQUESTS,
        badge: true,
        icon: MdAppRegistration,
        path: "registration-requests",
      },
];
